import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TextModes } from '../../../../ui/controls/text-input/text-input.component';
import { CacheService } from '../../../../../core/storage/cacheService';
import { MerchantProcessor } from '../../../../../models/merchant/merchantProcessor';
import { MerchantProcessorService } from '../../../../../models/merchant/merchantProcessorService';
import { ListItem } from '../../../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-merchant-processor-dialog',
  templateUrl: './merchant-processor-dialog.component.html',
  standalone: false,
})
export class MerchantProcessorDialogComponent {
  processorToEdit: Partial<MerchantProcessor>;

  textModes = TextModes;
  status: ListItem[] = CacheService.accountStatusList;
  processor: ListItem[] = CacheService.ccProcessorList;
  gateway: ListItem[] = CacheService.gatewayList;
  processorType: ListItem[] = CacheService.processingTypeList;
  readonly: boolean = true;

  constructor(
    private merchantProcessorService: MerchantProcessorService,
    private dialogRef: MatDialogRef<MerchantProcessorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: Partial<MerchantProcessor>,
  ) {
    this.processorToEdit = data;
  }

  public btnSave_click() {
    // validate...

    if (this.processorToEdit.id == undefined) {
      this.merchantProcessorService
        .addMerchantProcessor(this.processorToEdit)
        .then(() => {
          this.dialogRef.close(this.processorToEdit);
        });
    } else {
      this.merchantProcessorService
        .updateMerchantProcessor(this.processorToEdit)
        .then(() => {
          this.dialogRef.close(this.processorToEdit);
        });
    }
  }

  public btnCancel_click() {
    this.dialogRef.close();
  }
}
